/* eslint-disable vue/no-unused-components */
<template>
  <div class="container-fluid">
    <PointPresenceEditorDialog
      v-if="activePointPresence != null"
      ref="pointPresenceEditorDialog"
      :item="activePointPresence"
      :hidePlacementField="placementId != null"
      :title="'Ajout de présence au poste'"
      @save="savePointPresence"
    />
    <PointPresenceClotureEditorDialog
      v-if="activePointPresence != null"
      ref="pointPresenceClotureEditorDialog"
      :item="activePointPresence"
      :hidePlacementField="placementId != null"
      :title="'Clôture de point de présence au poste'"
      @save="handleCloturerPointPresence"
    />
    <div class="container- mt-1">
      <p-progress-bar v-if="mxLoading" style="height: 0.33em" mode="indeterminate" />
      <div class="bg-white p-2 rounded-4">
        <form class="bg-" method="post" accept-charset="utf-8" action="">
          <div class="row py-0 p-fluid grid formgrid">
            <div class="col field">
              <form class="d-flex">
                <div class="input-group me-4">
                  <div class="p-inputgroup">
                    <PInputText
                      type="text"
                      v-model="mxSearch"
                      :placeholder="'Rechercher par'"
                    />
                    <p-multi-select
                      v-model="mxSearchFields"
                      :options="searchFieldsOptions.filter((el) => el.visible)"
                      optionLabel="label"
                      optionValue="value"
                      :editable="true"
                    />
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-3 col-sm-12 d-flex">
              <div class="input-group me-4">
                <div class="p-inputgroup">
                  <p-dropdown
                    class="flex-grow-1 me-2"
                    v-model="status"
                    :options="statusOptions"
                    optionLabel="label"
                    optionValue="value"
                    :placeholder="'Statut'"
                    display="chip"
                  />
                </div>
              </div>
            </div>
            <div class="col-auto">
              <div class="d-grid gap-2">
                <a
                  href="#"
                  @click.prevent="mxSubmitQuery"
                  class="style_btn btn btn-primary"
                  id="button-query"
                  ><i class="bi bi-search"></i
                ></a>
              </div>
            </div>
            <div class="col-auto">
              <button
                type="button"
                @click.prevent="showAdvancedFilter = !showAdvancedFilter"
                class="style_btn btn btn-warning"
                id="button-query"
              >
                <i class="bi bi-filter"></i>
              </button>
            </div>
          </div>
        </form>
        <transition>
          <div class="card mx- border-radius-5 mt-2 hadow-5" v-if="showAdvancedFilter">
            <div class="row p-fluid p-3 grid">
              <template v-for="(option, index) in filterOptions">
                <div class="col-12 col-md-3 mb-4" v-if="option.visible" :key="index">
                  <label for="basic">{{ option.label }}</label>
                  <c-auto-complete
                    v-if="option.url"
                    display="chip"
                    v-model="option.value"
                    chips
                    :option="option"
                    :force-selection="true"
                  />
                  <p-multi-select
                    v-else-if="option.items && option.items.length != 0"
                    v-model="option.value"
                    :options="option.items"
                    :optionLabel="option.key"
                    :placeholder="option.label"
                    display="chip"
                  />
                  <p-input-text
                    v-else
                    v-model="option.value"
                    :placeholder="option.label"
                  />
                </div>
              </template>
            </div>
          </div>
        </transition>
      </div>
      <p-divider />
      <div class="d-flex flex-wrap mb-4 justify-content-between align-items-center">
        <div class="my-1 flex-fill">
          <h4>
            Liste des points de présence au poste
            {{
              placementId != null && listTitleSuffix != null
                ? " - " + listTitleSuffix.toUpperCase()
                : ""
            }}
          </h4>
        </div>
        <div class="btn-group">
          <a
            @click.prevent="showPointPresenceEditorDialog"
            href=""
            class="ms-2 style_btn btn btn-warning"
          >
            Créer un point de présence
          </a>
        </div>
        <PMessage
          v-show="errorMessage"
          :severity="'error'"
          @close="errorMessage = null"
          >{{ errorMessage }}</PMessage
        >
        <div v-if="$can('export', 'Azoli')" class="btn-group ms-4">
          <PSplitButton
            label="Exporter"
            :model="exportActions"
            class="p-button-outlined p-button-primary"
          />
        </div>
        <div class="btn-group ms-4">
          <button
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Affichage mode tableau"
            @click.prevent="viewMode = 'card'"
            class="btn style_btn btn-md"
            :class="{
              'btn-success': viewMode == 'card',
              'btn-light': viewMode == 'table',
            }"
          >
            <i class="bi-grid" />
          </button>
          <button
            @click.prevent="viewMode = 'table'"
            class="btn style_btn"
            :class="{
              'btn-light': viewMode == 'card',
              'btn-success': viewMode == 'table',
            }"
          >
            <i class="bi-table" />
          </button>
        </div>
      </div>

      <template v-if="!mxLoading">
        <div class="bg-">
          <div class="bg-white p-3 border">
            <div class="table-responsive">
              <b-table
                show-empty
                empty-text="Aucune donnée à afficher"
                :fields="tableFields"
                class="align-middle"
                striped
                select-mode="multi"
                ref="table"
                selectable
                @row-selected="onRowSelected"
                :items="tableData"
              >
                <template #head()="data">
                  <span>{{ data.label }} </span>
                </template>
                <template #head(#)="data">
                  <div class="form-check form-check-inline">
                    <input
                      @change="selectAll"
                      class="form-check-input"
                      type="checkbox"
                      :id="`${data.index}`"
                      name="disponible"
                      :value="false"
                    />
                  </div>
                </template>
                <!-- A virtual column -->
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(#)="data">
                  <div class="form-check form-check-inline">
                    <input
                      @input="selectionChanged($event, data)"
                      :checked="data.rowSelected"
                      class="form-check-input"
                      type="checkbox"
                      :id="`${data.index}`"
                      name="disponible"
                    />
                  </div>
                </template>

                <template #cell(status)="{ item: cand }">
                  <PTag
                    class="text-uppercase badge badge-primary"
                    :severity="getStatusColor(cand.status)"
                    v-if="cand.status"
                    >{{ cand.status }}
                  </PTag>
                </template>
                <template #cell(isEvalue)="{ item: de }">
                  <span class="text-uppercase">
                    <i
                      v-if="de.isEvalue"
                      v-tooltip.left="'Evaluée'"
                      class="bi bi-check-circle text-success"
                      style="font-size: 1.5rem"
                      v-badge.success="de.typeCandidature == 'RECOMMANDE' ? 'R' : 'S'"
                    ></i>
                    <i
                      v-else
                      v-tooltip.left="'Non évaluée'"
                      class="bi bi-slash-circle text-danger"
                      style="font-size: 1.5rem"
                      v-badge.danger="de.typeCandidature == 'RECOMMANDE' ? 'R' : 'S'"
                    ></i>
                  </span>
                </template>
                <template #cell(nom)="{ item: de }">
                  <span class="text-uppercase">{{ de.nom }}</span>
                </template>
                <template #cell(dateDu)="{ item: de }">
                  <span class="text-uppercase">{{
                    $dayjs(de.dateDu).format("DD-MM-YYYY")
                  }}</span>
                </template>
                <template #cell(dateAu)="{ item: de }">
                  <span class="text-uppercase">{{
                    $dayjs(de.dateAu).format("DD-MM-YYYY")
                  }}</span>
                </template>
                <template #cell(dateMoisPointPresence)="{ item: de }">
                  <span class="text-uppercase">{{
                    de.dateMoisPointPresence != null
                      ? $dayjs(de.dateMoisPointPresence).format("MMM YYYY")
                      : "-"
                  }}</span>
                </template>
                <template #cell(prenom)="{ item: de }">
                  <span class="text-uppercase">{{ de.prenom }}</span>
                </template>
                <template #cell(posteOccupe)="{ item: de }">
                  <div class="ellipsis" v-tooltip.top="de.posteOccupe">
                    {{ de.posteOccupe | truncate() }}
                  </div>
                </template>

                <template #row-details="row">
                  <PresencePosteList
                    :pointPresence="row.item"
                    :listTitleSuffix="listTitleSuffix"
                    :extraQueryArg="`pointPresenceId=${row.item.id}`"
                    @cloturer="showCloturerPointPresence"
                    @valider="showValiderPointPresence"
                  />
                </template>

                <template #cell(actions)="row">
                  <div class="d-flex justify-content-end">
                    <button
                      class="btn btn-sm py-1 btn-outline-primary me-1"
                      v-tooltip.top="'Voir les points de présences'"
                      @click="mxToggleDetails(row, tableData)"
                    >
                      <i class="bi bi-journal-check"></i>
                    </button>
                    <!-- <a class="btn btn-warning rounded-0 btn-sm me-1" v-tooltip.top="'Présence au poste'"  @click.stop="showPointPresenceEditorDialog(pp)" ><i class="bi bi-person-check"></i></a> -->
                    <button
                      class="btn btn-outline-warning rounded-0 btn-sm me-1"
                      v-tooltip.top="'Clôturer le point de présence'"
                      @click.stop="showCloturerPointPresence(row.item)"
                      v-if="
                        $can('CLOTURER', 'POINT_PRESENCE') &&
                        !['CLOTURE', 'VALIDE'].includes(row.item.status)
                      "
                    >
                      <i class="bi bi-slash-circle"></i>
                    </button>
                    <button
                      class="btn btn-outline-success rounded-0 btn-sm me-1"
                      v-tooltip.top="'Valider le point de présence'"
                      @click.stop="showValiderPointPresence(row.item)"
                      v-if="
                        $can('VALIDER', 'POINT_PRESENCE') && row.item.status == 'CLOTURE'
                      "
                    >
                      <i class="bi bi-check"></i>
                    </button>
                  </div>
                </template>
                <!-- Optional default data cell scoped slot -->
                <template #cell()="data">
                  <span>{{ data.value }}</span>
                </template>
              </b-table>
            </div>
            <div class="d-flex flex-wrap justify-content-between align-items-center">
              <p>
                Affichage de l’élément
                {{ mxPagination.page * mxPagination.rowsPerPage }} à
                {{ (mxPagination.page + 1) * mxPagination.rowsPerPage }} de
                {{ mxTotalCount }} éléments
              </p>
              <b-pagination
                v-model="mxPagination.page"
                :total-rows="mxTotalCount"
                :per-page="mxPagination.rowsPerPage"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div>
          <PDataTable
            :value="
              [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((e) => {
                e;
              })
            "
          >
            <PColumn
              v-for="f in tableFields"
              :key="f.key"
              :field="f.key"
              :header="f.label"
            >
              <template #body>
                <PSkeleton></PSkeleton>
              </template>
            </PColumn>
          </PDataTable>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { paginatorMixin } from "@/mixins/paginator-mixin";
import { authMixin } from "../../../../mixins/auth-mixin";

import PointPresenceEditorDialog from "../../../../components/espace/entreprise/editor/PointPresenceEditorDialog.vue";
import PointPresenceClotureEditorDialog from "../../../../components/espace/entreprise/editor/PointPresenceClotureEditorDialog.vue";
import PresencePosteList from "./PresencePosteList.vue";

export default {
  props: {
    listTitleSuffix: {
      type: String,
      default: null,
    },
    extraQueryArg: {
      type: String,
      default: "",
    },
    placementId: {
      type: Number,
      default: null,
    },
  },
  components: {
    PointPresenceEditorDialog,
    PointPresenceClotureEditorDialog,
    PresencePosteList,
  },
  mixins: [paginatorMixin, authMixin],
  data() {
    return {
      selected: [],
      search: "",
      activePriseDeService: {},
      activeCessationService: {},
      activePointPresence: {},
      pointPresence: null,
      dateDeb: null,
      dateFin: null,
      errorMessage: null,
      showAdvancedFilter: false,
      viewMode: localStorage.getItem("viewMode") || "table", //card, table
      statusOptions: [
        { value: null, label: "Tous" },
        { value: "NON_DEMARRE", label: "NON_DEMARRE" },
        { value: "EN_COURS", label: "EN_COURS" },
        { value: "CLOTURE", label: "CLOTURE" },
        { value: "VALIDE", label: "VALIDE" },
      ],
      status: null,
      exportActions: [
        {
          label: "PDF",
          icon: "pi pi-file-pdf",
          command: () => {
            this.mxExportToPDF({
              meta: {
                title: "Liste des points de présences",
                subtitle: "Liste des points de présences",
              },
              pathParams: {
                name: "common.export",
                query: {
                  apiPath: "pointPresences/exportToPdf",
                  queryParams: this.mxGetQueryBuilder(),
                  fileName: "Liste des points de présences.pdf",
                },
              },
            });
          },
        },
        {
          label: "Excel",
          icon: "pi  pi-file-excel",
          command: () => {
            this.mxExportToExcel({
              meta: {
                title: "Liste des points de présences",
                subtitle: "Liste des points de présences",
              },
              pathParams: {
                name: "common.export",
                query: {
                  apiPath: "pointPresences/exportToExcel",
                  queryParams: this.mxGetQueryBuilder(),
                  fileName: "Liste des points de présences.xlsx",
                },
              },
            });
          },
        },
      ],
      searchFields: ["intituleOffre"],
      searchFieldsOptions: [
        {
          label: "Référence placement",
          value: "referencePlacement",
          visible: this.$can("filter.beneficiaire", "Azoli"),
        },
        {
          label: "Titre offre",
          value: "intituleOffre",
          visible: this.$can("filter.telephone", "Azoli"),
        },
      ],
      filterOptions: [],
    };
  },
  created() {
    this.queryStatistics();
  },
  watch: {
    viewMode() {
      localStorage.setItem("viewMode", this.viewMode);
    },
  },
  computed: {
    ...mapGetters({
      dossier: "demandeur/demandeur",
      statutDossiers: "setting/statutDossiers",
      // demandeurs: 'demandeur/demandeurs',
      pagination: "demandeur/pagination",
    }),
    tableFields() {
      return [
        "#",
        // 'index',
        { key: "referencePlacement", label: "Ref.Placement" },
        { key: "intituleOffre", label: "Nom" },
        { key: "dateMoisPointPresence", label: "Mois" },
        { key: "dateDu", label: "Début.Cont" },
        { key: "dateAu", label: "Fin.Cont" },
        { key: "status", label: "Statut" },
        // { key: 'validePar', label: 'Validé par' },
        "actions",
      ];
    },
    tableData() {
      return this.mxFilteredItems.map((item) => {
        return { ...item };
      });
    },
  },
  methods: {
    ...mapActions({
      createOrUpdatePriseService: "priseService/createOrUpdatePriseService",
      createOrUpdateArretContrat: "arretContrat/createOrUpdateArretContrat",
      createOrUpdatePointPresence: "pointPresence/createOrUpdatePointPresence",
      cloturerPointPresence: "pointPresence/cloturerPointPresence",
      validerPointPresence: "pointPresence/validerPointPresence",
      recommanderProfils: "offre/recommanderProfils",
    }),
    showPointPresenceEditorDialog() {
      this.activePointPresence = {};
      if (this.placementId != null) {
        this.activePointPresence.placement = { id: this.placementId };
      }
      this.$refs.pointPresenceEditorDialog.show();
    },
    savePointPresence(pointPresence) {
      this.createOrUpdatePointPresence(pointPresence)
        .then((data) => {
          this.$toast.success("Présence au poste sauvegardée avec succès!", {
            position: "top-right",
            duration: 8000,
          });
          this.queryStatistics();
        })
        .catch((err) => err);
    },
    saveCessationService(cessationService) {
      this.createOrUpdateArretContrat(cessationService)
        .then((data) => {
          this.$toast.success("Cessation de service sauvegardée avec succès!", {
            position: "top-right",
            duration: 8000,
          });
        })
        .catch((err) => err);
    },
    priseEnCharge(de) {
      this.$router.push({
        name: "espace.common.de.followup",
        params: { userRole: this.$route.params.userRole, demandeurId: de.id },
      });
    },
    statisticBlockSelected(status) {
      this.mxSetOptionValue("status", status, true);
    },
    getStatusColor(status) {
      let color = "";
      if (status == "EN_COURS") {
        color = "primary";
      } else if (status == "VALIDE") {
        color = "success";
      } else if (status == "CLOTURE") {
        color = "warning";
      } else if (status == "RECALE") {
        color = "danger";
      } else if (status == "PROPOSE") {
        color = "info";
      } else if (status == "NON_DEMARRE") {
        color = "secondary";
      }
      return color;
    },
    queryStatistics() {
      this.mxInitializePaginator({
        queryModel: "pointPresence",
        search: this.search,
        fetcherMethod: "pointPresence/fetchPointPresences",
        dataGetter: "pointPresence/pointPresences",
        paginationGetter: "pointPresence/pagination",
        autoSubmitQuery: false,
        pagination: {
          sortBy: "id",
          descending: false,
          page: 0,
          rowsPerPage: 10,
          sortingParam: `sort=id,desc`,
        },
        filterOptions: this.filterOptions,
        extraQueryArgsParamBuilder: () => {
          const dateDeb = (this.dateDeb || new Date("2021-12-31"))
            .toISOString()
            .substring(0, 10);
          const dateFin = (this.dateFin || new Date("2080-12-31"))
            .toISOString()
            .substring(0, 10);

          let paramPlus = this.mxAddQueryParam("status", this.status);

          let params = `createdDate=${dateDeb}&createdDate=${dateFin}&${this.extraQueryArg}&${paramPlus}`;
          return params;
        },
        searchFields: this.searchFields,
      });
    },
    selectionChanged(evt, data) {
      console.log(evt.target.checked, data);

      if (evt.target.checked) {
        this.$refs.table.selectRow(data.index);
      } else {
        this.$refs.table.unselectRow(data.index);
      }
    },
    onRowSelected(items) {
      this.selected = items;
    },
    selectAll(evt) {
      if (evt.target.checked) {
        this.$refs.table.selectAllRows();
      } else {
        this.$refs.table.clearSelected();
      }
    },
    uploadFile(de) {
      console.log(de);
      this.$refs[`pond2`].click();
    },
    onProgress(e) {
      console.log(e);
    },
    async showCloturerPointPresence(pointPresence) {
      this.activePointPresence = pointPresence;
      this.$refs.pointPresenceClotureEditorDialog.show();
    },
    async handleCloturerPointPresence(pointPresence) {
      await this.$confirm.require({
        group: "confirmDialog",
        message: `Voulez-vous vraiment clôturer le point de présence du mois de ${this.$dayjs(
          pointPresence.dateMoisPointPresence
        ).format("MMM YYYY")} ?`,
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.cloturerPointPresence({
            ...pointPresence,
          }).then((data) => {
            this.$toast.success("Recommandation retirée avec succès!", {
              position: "top-right",
              duration: 8000,
            });
            // this.queryStatistics()
          });
        },
      });
    },
    async showValiderPointPresence(pointPresence) {
      await this.$confirm.require({
        group: "confirmDialog",
        message: `Voulez-vous vraiment valider le point de présence du mois de ${this.$dayjs(
          pointPresence.dateMoisPointPresence
        ).format("MMM YYYY")} ?`,
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.validerPointPresence({
            ...pointPresence,
          }).then((data) => {
            this.$toast.success("Recommandation retirée avec succès!", {
              position: "top-right",
              duration: 8000,
            });
            // this.queryStatistics()
          });
        },
      });
    },
    async retirerRecommanationCandidature(candidature) {
      await this.$confirm.require({
        group: "confirmDialog",
        message: `Voulez-vous vraiment retirer cette candidature recommandée de ${candidature.candidat.nomPrenom} ?`,
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.retirerRecommanation({
            ...candidature,
          }).then((data) => {
            this.$toast.success("Recommandation retirée avec succès!", {
              position: "top-right",
              duration: 8000,
            });
            // this.queryStatistics()
          });
        },
      });
    },
    async recommanderProfilSelectionnes(demandeurs) {
      this.recommanderProfils({
        offreId: this.offreId,
        demandeurs,
      }).then((data) => {
        this.$toast.info("Canditatures recommandées avec succès!", {
          position: "top-right",
          duration: 8000,
        });
        this.queryStatistics();
      });
    },
  },
};
</script>

<style>
.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
